// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const SelectTrigger = createStyle({
  borderWidth: 1,
  borderColor: '$borderLight',
  borderRadius: '$sm',
  flexDirection: 'row',
  overflow: 'hidden',
  alignItems: 'center',
  backgroundColor: '$bgCard',

  ':hover': {
    borderColor: '$borderMedium',
  },

  ':focus': {
    borderColor: '$borderFocus',
  },

  ':disabled': {
    opacity: 0.4,
    ':hover': {
      borderColor: '$borderLight',
    },
  },

  _input: {
    py: 'auto',
    px: '$3',
  },

  _icon: {
    color: '$textHint',
    _dark: {
      color: '$textHint',
    },
  },

  _dark: {
    borderColor: '$borderLight',
    backgroundColor: '$bgCard',
    ':hover': {
      borderColor: '$borderMedium',
    },
    ':focus': {
      borderColor: '$borderFocus',
    },
    ':disabled': {
      ':hover': {
        borderColor: '$borderLight',
      },
    },
  },

  variants: {
    size: {
      xl: {
        h: '$12',
        _input: {
          fontSize: '$xl',
        },
        _icon: {
          h: '$6',
          w: '$6',
        },
      },
      lg: {
        h: '$11',
        _input: {
          fontSize: '$lg',
        },
        _icon: {
          h: '$5',
          w: '$5',
        },
      },
      md: {
        h: '$10',
        _input: {
          fontSize: '$md',
        },
        _icon: {
          h: '$4',
          w: '$4',
        },
      },
      sm: {
        h: '$9',
        _input: {
          fontSize: '$sm',
        },
        _icon: {
          h: '$3.5',
          w: '$3.5',
        },
      },
      xs: {
        h: '$8',
        _input: {
          fontSize: '$xs',
        },
        _icon: {
          h: '$3.0',
          w: '$3.0',
        },
      },
    },
    variant: {
      underlined: {
        _input: {
          _web: {
            outlineWidth: 0,
            outline: 'none',
          },
          px: '$0',
        },
        borderWidth: 0,
        borderRadius: 0,
        borderBottomWidth: '$1',
        ':focus': {
          borderColor: '$borderFocus',
          _web: {
            boxShadow: 'inset 0 -1px 0 0 $borderFocus',
          },
          ':hover': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 -1px 0 0 $borderFocus',
            },
          },
        },
        ':invalid': {
          borderBottomWidth: 2,
          borderBottomColor: '$statusError',
          _web: {
            boxShadow: 'inset 0 -1px 0 0 $statusError',
          },
          ':hover': {
            borderBottomColor: '$statusError',
          },
          ':focus': {
            borderBottomColor: '$statusError',
            ':hover': {
              borderBottomColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 -1px 0 0 $statusError',
              },
            },
          },
          ':disabled': {
            ':hover': {
              borderBottomColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 -1px 0 0 $statusError',
              },
            },
          },
        },
        _dark: {
          ':focus': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 -1px 0 0 $borderFocus',
            },
          },
          ':invalid': {
            borderColor: '$statusError',
            _web: {
              boxShadow: 'inset 0 -1px 0 0 $statusError',
            },
            ':hover': {
              borderBottomColor: '$statusError',
            },
            ':focus': {
              borderBottomColor: '$statusError',
              ':hover': {
                borderBottomColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 -1px 0 0 $statusError',
                },
              },
            },

            ':disabled': {
              ':hover': {
                borderBottomColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 -1px 0 0 $statusError',
                },
              },
            },
          },
        },
      },
      outline: {
        _input: {
          _web: {
            outlineWidth: 0,
            outline: 'none',
          },
        },
        ':focus': {
          borderColor: '$borderFocus',
          _web: {
            boxShadow: 'inset 0 0 0 1px $borderFocus',
          },
          ':hover': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 0 0 1px $borderFocus',
            },
          },
        },
        ':invalid': {
          borderColor: '$statusError',
          _web: {
            boxShadow: 'inset 0 0 0 1px $statusError',
          },
          ':hover': {
            borderColor: '$statusError',
          },
          ':focus': {
            borderColor: '$statusError',
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
          ':disabled': {
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
        },
        _dark: {
          ':focus': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 0 0 1px $borderFocus',
            },
          },
          ':invalid': {
            borderColor: '$statusError',
            _web: {
              boxShadow: 'inset 0 0 0 1px $statusError',
            },
            ':hover': {
              borderColor: '$statusError',
            },
            ':focus': {
              borderColor: '$statusError',
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
            ':disabled': {
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
          },
        },
      },
      rounded: {
        borderRadius: 999,
        _input: {
          px: '$4',
          _web: {
            outlineWidth: 0,
            outline: 'none',
          },
        },
        ':focus': {
          borderColor: '$borderFocus',
          _web: {
            boxShadow: 'inset 0 0 0 1px $borderFocus',
          },
          ':hover': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 0 0 1px $borderFocus',
            },
          },
        },
        ':invalid': {
          borderColor: '$statusError',
          _web: {
            boxShadow: 'inset 0 0 0 1px $statusError',
          },
          ':hover': {
            borderColor: '$statusError',
          },
          ':focus': {
            borderColor: '$statusError',
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
          ':disabled': {
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
        },

        _dark: {
          ':focus': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 0 0 1px $borderFocus',
            },
          },
          ':invalid': {
            borderColor: '$statusError',
            _web: {
              boxShadow: 'inset 0 0 0 1px $statusError',
            },
            ':hover': {
              borderColor: '$statusError',
            },
            ':focus': {
              borderColor: '$statusError',
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
            ':disabled': {
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
          },
        },
      },
    },
  },

  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
});
